"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cNewApplicationSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../../hooks");
exports.cNewApplicationSchema = zod_1.z.strictObject({
    event: zod_1.z.literal(hooks_1.HookName.newApplication),
    action: zod_1.z.literal(hooks_1.HookName.newApplication),
    meta: zod_1.z.optional(zod_1.z.strictObject({
        requester: zod_1.z.number()
    })),
    qaUrl: zod_1.z.optional(zod_1.z.string()),
    entityId: zod_1.z.optional(zod_1.z.string().uuid()),
    userListId: zod_1.z.optional(zod_1.z.string().uuid()),
    membershipId: zod_1.z.optional(zod_1.z.string().uuid()),
    applicationId: zod_1.z.string().uuid(),
    /** ID of the admin user list that manages this application */
    applicationManagedBy: zod_1.z.optional(zod_1.z.string().uuid().or(zod_1.z.literal(''))),
    /** ID of the user who initiated this application */
    requestingAccountId: zod_1.z.number(),
    /**
     * If the application has a management list (`applicationManagedBy`),
     * it will be put into `listIds` along with the `userLists` returned
     * from `findNotificationEvent()`. Notifications will be sent to the
     * users on these lists.
     */
    listIds: zod_1.z.optional(zod_1.z.array(zod_1.z.string().uuid()))
});
